import { fadeIn, updateColors } from "../animations";
import { toggleDisplay, initSection, updateDynamicElems } from "../utils";
import {
  Slider,
  Accordion,
  ComboBox,
  QtySelector,
  AddToCart,
  TopBar,
} from "../global";

/**
 *
  Contains the implementation of the subscription form.
  It initializes and updates various elements and components on the page based on user interaction
  by searching for elements with specific data attributes ( [data-update] ) and replacing their content with the new value.

  @module subscriptionForm
 *
 *
  @property {Element} container - The subscription barba container element
  @property {Element} form - The product form element
  @property {QtySelector} qty_selector - The quantity selector component instance
  @property {ComboBox} combo_box - The combo box component instance
  @property {AddToCart} atc_button - The add to cart button component instance
  @property {TopBar} top_bar - The top bar component instance
  @property {NodeList} all_swatches - A list of all swatch elements in the form
  @property {NodeList} dynamic_elems - A list of all dynamic elements to update when a swatch is clicked
  @property {Element} accordion_group_container - The container element for all accordion groups
  @property {Element} reviews_container - The container element for product reviews
*/

const state = {
  container: false,
  form: false,
  qty_selector: false,
  combo_box: false,
  atc_button: false,
  top_bar: false,
  all_swatches: false,
  dynamic_elems: false,
  accordion_group_container: false,
  reviews_container: false,
};

/**
  Initializes the subscription form by setting up various elements and components.
*/
const _initForm = () => {
  state.container = document.getElementById("subscription-barba-container");
  state.form = document.querySelector("product-form");
  if (!state.container || !state.form) return;

  try {
    state.qty_selector = new QtySelector(state.form);
    state.combo_box = new ComboBox(state.form);
    state.atc_button = new AddToCart(
      state.form,
      state.qty_selector,
      state.combo_box
    );
    state.top_bar = new TopBar();
  } catch (e) {
    console.error(e);
  }

  state.all_swatches = state.form.querySelectorAll(".product-swatch");
  state.dynamic_elems = document.querySelectorAll("[data-update]");
  state.accordion_group_container = document.getElementById(
    "accordion-group-container"
  );
  state.reviews_container = document.getElementById("reviews_container");
  state.all_swatches.forEach((swatchEl) => {
    swatchEl.addEventListener("click", _handleUpdate);
  });

  fadeIn(state.container);
};

/**
  Event handler that updates various elements on the page based on the clicked swatch.
  @param {Event} e - The event object triggered by the click event.
*/
const _handleUpdate = (e) => {
  const newSwatchEl = e.currentTarget;
  const newProductHandle = newSwatchEl.dataset.handle;

  updateColors(newSwatchEl);
  toggleDisplay(
    newProductHandle,
    state.accordion_group_container,
    "product-accordion"
  );
  toggleDisplay(
    newProductHandle,
    state.reviews_container,
    "subscription-reviews"
  );
  updateDynamicElems(newSwatchEl, state.dynamic_elems, state.form);
};

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.body.dataset.suffix == "subscription") {
    _initForm();
    initSection("slider-container", Slider);
    initSection("accordion-group", Accordion);
  }
});
